import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { MdAdd } from "react-icons/md";
import TableCategories from "./components/TableCategories";
import AddCategories from "./components/AddCategories";

function Categories() {
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`/api_w/postcategories`, {
        headers: { db_name: process.env.REACT_APP_DB_NAME },
      });
      setCategories(response.data.data);
    } catch (error) {
      toast.error(
        "Error fetching kategori: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <div className="mt-5 px-2">
      {/* Page Header */}
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-navy-700">Kategori Postingan</h2>
          <p className="mt-1 text-sm text-gray-500">Kelola kategori untuk mengelompokkan postingan</p>
        </div>
        <button
          onClick={() => setShowAddPopup(true)}
          className="flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-bold text-white shadow-sm transition-all hover:opacity-90"
          style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}
        >
          <MdAdd className="h-5 w-5" />
          Tambah Kategori
        </button>
      </div>

      {/* Table Card */}
      <div className="rounded-2xl bg-white shadow-sm overflow-hidden">
        <TableCategories
          categories={categories}
          fetchCategories={fetchCategories}
        />
      </div>

      {showAddPopup && (
        <AddCategories
          onClose={() => setShowAddPopup(false)}
          fetchCategories={fetchCategories}
        />
      )}
    </div>
  );
}

export default Categories;
